import styled from 'styled-components'

const DashCircle = () => {
  return <DashCircleStyle />
}

const DashCircleStyle = styled.div`
  position: absolute;
  top: 50%;
  left: -1px;
  transform: translate(0, -50%);
  background: inherit;
  border: 2px dashed #ff9b57;
  border-radius: 50%;
  width: calc(100vw * (69 / 375));
  height: calc(100vw * (69 / 375));
  pointer-events: none;
`

export default DashCircle
